/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        var $hb = $('html,body'),
          targetYoffset = 20;
        $('.carousel').carousel();
        $('body').on('click', 'a[href^="#"]', function (e) {
          var href = this.getAttribute('href'),
            role = this.getAttribute('role'),
            $target, targetY;
          if (role === 'button' || role === 'tab') {
            return;
          }
          if (href === '#top') {
            targetY = 0;
          }
          else {
            $target = $(href);
            if (($target.length === 0)) {
              console.log('target not found ' + href);
              return;
            }
            else {
              targetY = $target.position().top;
              targetY = Math.max(0, targetY - targetYoffset);
            }
          }
          e.preventDefault();
          $hb.animate({scrollTop: targetY}, {duration: 500});
        });
	$('.submit').on('click', function (e) {
		var $form = $(this).closest('.wpcf7-form');
		$form.submit();
	});
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    'page_template_template_anfrage': {
      init: function () {
	var compile = function () {
		var value = '';
		$.each(document.forms['anfrage'].elements, function (idx, el) {
			var id_prop = el.name.split('_'), id = id_prop[0], prop = id_prop[1];
			if (prop === 'menge' && el.value !== '') {
				value += id + ': ' + document.forms['anfrage'].elements[id + '_einheit'].value + ' x ' + el.value;
				value += '\n';
			}
		});
		return value;
	};
	$('.submit').on('click', function (e) {
		var compiled = compile(),
			$form = $(this).closest('.wpcf7-form');
		$form.find('[name="anfrage"]').val(compiled);
		$form.submit();
	});
      }
    },
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
